/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Readable } from '../../models/readable';

export interface ReportsControllerGetStaticReportSectionFile$Params {

/**
 * Static report section ID.<p>A HEX string containing 24 characters, representing unique identifier string.</p>
 */
  id: string;
}

export function reportsControllerGetStaticReportSectionFile(http: HttpClient, rootUrl: string, params: ReportsControllerGetStaticReportSectionFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
  const rb = new RequestBuilder(rootUrl, reportsControllerGetStaticReportSectionFile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Readable>;
    })
  );
}

reportsControllerGetStaticReportSectionFile.PATH = '/planning-projects/v1-preview/reports/static-report-sections/{id}/files';
